import { ELkType } from '../../repositories/lk-type/entities/get_lk_type_v2/GetLkTypeResponseV2';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EGetLkTypeStatus {
  Succeed = 'LK_TYPE/SUCCEED',
}

export type TGetLkTypeSucceed = ITypedReduxAction<EGetLkTypeStatus.Succeed, ELkType | null>;

export const setLkType = actionGenerator<EGetLkTypeStatus.Succeed, ELkType | null>(EGetLkTypeStatus.Succeed);
